const getMediaUrl = () => import.meta.env.VITE_MEDIA_URL || "https://back.sewargourmet.com";

export const SetSrc = (url: string, type: "Full" | "Media" = "Media") => {
  if (!url) return "";

  // If the URL is already absolute (http/https/blob/data), return as-is
  if (
    url.startsWith("http://") ||
    url.startsWith("https://") ||
    url.startsWith("blob:") ||
    url.startsWith("data:")
  ) {
    return url;
  }

  // Local frontend assets
  if (
    url.startsWith("/images/") ||
    url.startsWith("/icons/") ||
    url.startsWith("/fonts/") ||
    url.startsWith("/favicon") ||
    url.startsWith("/ku-flag")
  ) {
    return url;
  }

  const api =
    type === "Full" ? (import.meta.env.VITE_API_URL || "https://back.sewargourmet.com/api") : getMediaUrl();

  // Normalize path: remove leading slashes
  let clean = url.replace(/\/+/g, "/").replace(/^\/+/, "");

  // If clean starts with "storage/", strip it to avoid double "/storage/storage"
  if (clean.startsWith("storage/")) {
    clean = clean.substring("storage/".length);
  }

  // Backend media paths are relative; prefix with media URL + /storage
  return `${api}/storage/${clean}`;
};
